// extracted by mini-css-extract-plugin
module.exports = {"no-bottom":"LightRegister_no-bottom_1HW9d","footer":"LightRegister_footer_1qcQP","vs-hide":"LightRegister_vs-hide_3SGAx"};